import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ClearTokenRedirectLogin } from 'utils/general';
import requestCheck from 'assets/images/Dashboard/chevron-right-request.svg';
import ArrowDetail from 'assets/images/Dashboard/arrow-left-request-detail.svg';
import LabelWithInput from 'components/commom/LabelWithPracticeInput';
import LabelWithTextArea from 'components/commom/LabelWithTextArea';
import ReusableButton from 'components/commom/Button';
import { getPracticeDetail } from 'store/getPracticeDetail/getPracticeDetailAction';
import { createPractice } from 'store/createPractice/createPracticeAction';
import { getSymptomsList } from 'store/symptomsList/symptomsListAction';
import { practices } from 'routes/AppUrls';
import { updatePractice } from 'store/updatePractice/updatePracticeAction';
import CheckValidation from 'utils/validate';
import { Select } from 'antd';
import styled from 'styled-components';
import CommonToast from 'components/commom/CommonToast';

const { Option } = Select;

const StyledSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  label {
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    color: #292d32 !important;
    font-family: outfit_medium;
    transform: none;
    margin-bottom: 8px;
  }

  .ant-select {
    width: 100%;
    border: none !important;
    border-bottom: 1px solid #efe3d7 !important;
    border-radius: 0;
    box-shadow: none !important;
  }

  .ant-select-selector {
    border: none !important;
    border-radius: 0;
    box-shadow: none !important;
    background: transparent;
  }

  .ant-select-focused .ant-select-selector {
    box-shadow: none !important;
  }

  .ant-select-selection-placeholder {
    color: #303438;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    font-family: outfit_regular;
  }
`;

const ErrorMessage = styled.div`
  font-size: 16px;
  color: red;
  line-height: 24px;
  font-family: outfit_regular;
`;

const PracticeDetail = () => {
  const { locale } = useContext(LocaleContext);
  const intl = useIntl();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [symptomsList, setSymptomsList] = useState([]);
  const [isError, setIsError] = useState(false);
  const [formValue, setformValue] = useState({
    practiceName: '',
    bioText: '',
    languages_slug: [],
  });

  const practiceValueId = useSelector(
    (state) => state?.basicDetailsValueReducer?.practiceValueId
  );

  const updateReducer = useSelector(
    (state) => state?.updatePracticeReducer?.loading
  );

  const createReducer = useSelector(
    (state) => state?.createPracticeReducer?.loading
  );

  useEffect(() => {
    if (practiceValueId) {
      getPracticeDetailValue();
    }
    SymptomsList();
  }, []);

  const SymptomsList = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setSymptomsList(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getSymptomsList(external));
  };

  const getPracticeDetailValue = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        handleSuccess(res);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getPracticeDetail(external, practiceValueId));
  };

  const handleSuccess = (res) => {
    setformValue((prev) => ({
      ...prev,
      practiceName: res?.data?.practice_name,
      bioText: res?.data?.description,
      languages_slug:
        res?.data?.associated_symptoms?.map((symptom) => ({
          id: symptom?.id,
          value: symptom?.name,
        })) || [],
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setformValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChange = (selectedValues) => {
    const selectedItems = symptomsList
      .filter((item) => selectedValues.includes(item.name))
      .map((item) => ({ id: item.id, value: item.name }));

    setformValue((prev) => ({
      ...prev,
      languages_slug: selectedItems,
    }));
  };

  const handlePractice = () => {
    if (practiceValueId) {
      const external = {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          navigate(practices(locale));
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      };
      const error = CheckValidation(formValue);
      setIsError(error);
      const associatedSymptomsIds = formValue?.languages_slug.map(
        (item) => item.id
      );
      if (error.submit) {
        let body = {
          practice_name: formValue?.practiceName,
          description: formValue?.bioText,
          associated_symptoms: associatedSymptomsIds,
        };
        dispatch(updatePractice(external, body, practiceValueId));
      }
    } else {
      const external = {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          navigate(practices(locale));
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      };
      const error = CheckValidation(formValue);
      setIsError(error);
      const associatedSymptomsIds = formValue?.languages_slug.map(
        (item) => item.id
      );
      if (error.submit) {
        let body = {
          practice_name: formValue?.practiceName,
          description: formValue?.bioText,
          associated_symptoms: associatedSymptomsIds,
        };
        dispatch(createPractice(external, body));
      }
    }
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainerrequest lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainerrequest lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="flex pb-16">
            <div className="fs-12 lh-24 family_outfit_regular_400">
              Practices
            </div>
            <div className="pl-04 flex items-center">
              <Image src={requestCheck} alt="icon" />
            </div>
            <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
              Add New Practice
            </div>
          </div>
          <Col md={12} lg={11} className="bg-light-100 p-0">
            <Row className="m-0 p-24">
              <Col md={12} className="p-0">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="flex items-center"
                >
                  <div>
                    <Image
                      src={ArrowDetail}
                      alt="icon"
                      onClick={() => navigate(-1)}
                      className="cursor-pointer"
                    />
                  </div>
                  <div className="fs-20 lh-252 family_outfit_semiBold_600 fc-292D32">
                    Add New Practice
                  </div>
                </Stack>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-24">
                  <LabelWithInput
                    label="Practice Name"
                    placeholder="New Practice Name"
                    name="practiceName"
                    type="text"
                    value={formValue?.practiceName}
                    onChange={handleInputChange}
                    errorText={
                      isError &&
                      isError?.practiceName?.error &&
                      isError?.practiceName?.errorMessage
                    }
                  />
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-24">
                  {formValue.languages_slug ? (
                    <StyledSelectWrapper>
                      <label htmlFor="language-select">
                        Associated Symptoms
                      </label>
                      <Select
                        mode="multiple"
                        id="language-select"
                        name="language"
                        value={formValue?.languages_slug}
                        placeholder="Associated Symptoms"
                        optionFilterProp="children"
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        onChange={handleChange}
                      >
                        {symptomsList.map((key) => (
                          <Option key={key?.id} value={key?.name}>
                            {key.name}
                          </Option>
                        ))}
                      </Select>
                      {isError && isError?.languages_slug?.error && (
                        <ErrorMessage>
                          {isError?.languages_slug?.errorMessage}
                        </ErrorMessage>
                      )}
                    </StyledSelectWrapper>
                  ) : (
                    <>
                      <StyledSelectWrapper>
                        <label htmlFor="language-select">
                          Associated Symptoms
                        </label>
                        <Select
                          mode="multiple"
                          id="language-select"
                          name="language"
                          value={formValue?.languages_slug}
                          placeholder="Associated Symptoms"
                          optionFilterProp="children"
                          filterSort={(optionA, optionB) =>
                            optionA.children
                              .toLowerCase()
                              .localeCompare(optionB.children.toLowerCase())
                          }
                          onChange={handleChange}
                        >
                          {symptomsList.map((key) => (
                            <Option key={key?.id} value={key?.name}>
                              {key.name}
                            </Option>
                          ))}
                        </Select>
                      </StyledSelectWrapper>

                      {isError && isError?.languages_slug?.error && (
                        <ErrorMessage>
                          {isError?.languages_slug?.errorMessage}
                        </ErrorMessage>
                      )}
                    </>
                  )}
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-24">
                  <LabelWithTextArea
                    label="Description"
                    placeholder={intl.formatMessage({ id: 'Write here...' })}
                    height="100"
                    multiline
                    name="bioText"
                    Color={'#292D32'}
                    padding={'8px'}
                    value={formValue?.bioText}
                    onChange={handleInputChange}
                    errorText={
                      isError &&
                      isError?.bioText?.error &&
                      isError?.bioText?.errorMessage
                    }
                  />
                </div>
              </Col>
              <Col md={12} className="p-0 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="flex items-center pt-40"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#864629"
                    fontSize="16px"
                    fontWeight="400"
                    padding="14px 55px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_regular"
                    onClick={() => navigate(-1)}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>
                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 49px"
                    height="44px"
                    bgColor="#864629"
                    brColor="#864629"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      (!updateReducer || !createReducer) && handlePractice();
                    }}
                    loading={updateReducer || createReducer}
                  >
                    <FormattedMessage id="Create Practice" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </Col>
        </Col>
      </Row>
    </div>
  );
};

export default PracticeDetail;
